import { CheckCircle, HourglassBottom } from "@mui/icons-material";
import moment from "moment";
import React from "react";
import RestaurantApiService from "../../api_service/restaurant_api_service";
import { button_green, button_red, primary_color_1 } from "../../themes/colors";
import { showAlert } from "../message_box/show_alert";

export default function KitchenCard({ order }) {
  const createdDate = moment(order.createdAt).format("DD MMM, hh:mm a");
  const timeAgo = moment(order.createdAt).fromNow();

  return (
    <div className="bg-white rounded-2xl shadow-md">
      <div
        className="flex flex-col p-4 rounded-t-2xl"
        style={{ background: primary_color_1 }}
      >
        <div className="flex flex-row justify-between">
          <div className="font-bold">Order #{order.id}</div>
          <div>Table {order.table.number}</div>
        </div>
        <div className="flex flex-row justify-between text-sm text-gray-100">
          <div>{createdDate}</div>
          <div>{timeAgo}</div>
        </div>
      </div>
      <div className="p-4 gap-4 flex flex-col">
        {order.order_items.map((item, index) => (
          <KitchenItem item={item} key={index} />
        ))}
      </div>
    </div>
  );
}

function KitchenItem({ item }) {
  const serveItem = () => {
    showAlert({
      head: "Are you sure?",
      body: `Tap on 'yes' if your're ready to serve ${item.quantity} x ${item.item.name}?`,
      actions: [
        {
          name: "No",
          color: button_red,
        },
        {
          name: "Yes",
          color: button_green,
          action: async () => {
            await RestaurantApiService().serveItemCall(item.id, true);
            RestaurantApiService().getKitchenList();
          },
        },
      ],
      isCustomer: false,
    });
  };

  return (
    <div className="flex flex-row border-b-2 pb-3">
      <div className="w-[18px] min-w-[18px] text-center">{item.quantity}</div>
      <div className="text-gray-400 px-1">x</div>
      <div className="flex flex-col w-full">
        <div className="flex flex-row justify-between w-full">
          <div>{item.item.name}</div>
          <div className="w-[20px]">
            {item.served ? (
              <CheckCircle color="success" />
            ) : (
              <HourglassBottom
                color="warning"
                className="cursor-pointer"
                onClick={serveItem}
              />
            )}
          </div>
        </div>
        <div>
          {item.modifiers.map((modifier, modIndex) => (
            <Modifier key={modIndex} modifier={modifier} />
          ))}
        </div>
      </div>
    </div>
  );
}

function Modifier({ modifier }) {
  return <div className="text-gray-400 text-sm">- {modifier}</div>;
}
